import React, { useEffect, useState } from 'react';
import styles from "./RegistrationForm.module.css";
import BreatheEV_Logo from '../Images/logo.png';
import { Image } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { BreathAPIs } from '../APIs/BreathAPIs'
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';
import { authLogin } from '../Actions/Auth';
import { useDispatch } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';


const EmailVerification = (props) => {
    const navigate = useNavigate();
    const { verificationToken } = useParams();
    const [verificationStatus, setVerificationStatus] = useState('Verifying...');
    const [isEmailVerified, setIsEmailVerified] = useState(null);
    const [isTokenExpired, setIsTokenExpired] = useState(null);
    const [isEmailSend, setIsEmailSend] = useState(false);
    const [email, setEmail] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        setVerificationStatus('Verifying...');
        BreathAPIs.emailAddressVerification(verificationToken)
            .then(response => {
                if (response && response.data && response.data.success) {
                    setVerificationStatus(response.data.message);
                    if (response?.data?.success && response?.data?.token) {
                        dispatch(authLogin(response?.data?.token));
                        setIsEmailVerified(true);
                    }
                    else {
                        setIsEmailVerified(false);
                    }
                } else {
                    const errorMessage = response.data && response.data.message
                        ? response.data.message
                        : 'Email address verification failed. Please try again.';
                    setVerificationStatus(errorMessage);
                    setIsEmailVerified(false);
                }
            })
            .catch(error => {
                if (error?.response?.data?.tokenExpired) {
                    setIsTokenExpired(true);
                }
                console.error('Error verifying email:', error);
                const errorMessage = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'An error occurred while verifying your email address. Please try again.';

                setVerificationStatus(errorMessage);
                setIsEmailVerified(false);
            });
    }, [verificationToken]);


    const handleGotoDashboard = () => {
        navigate('/');
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const reSendVerificationEmail = () => {
        if (!isValidEmail(email)) {
            setVerificationStatus('Please enter a valid email address.');
            return;
        }
        setIsEmailSend(null);
        BreathAPIs.reSendEmailVerification(email)
            .then(response => {
                if (response && response.data && response.data.success) {
                    setVerificationStatus(response.data.message);
                    setIsEmailSend(true);
                } else {
                    const errorMessage = response.data && response.data.message
                        ? response.data.message
                        : 'Failed to resend verification email. Please try again.';
                    setVerificationStatus(errorMessage);
                    setIsEmailSend(false);
                }
            })
            .catch(error => {
                console.error('Error resending verification email:', error);
                const errorMessage = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'An error occurred while resending the verification email. Please try again.';
                setVerificationStatus(errorMessage);
                setIsEmailSend(false);
            });
    };

    return (
        <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
                        <div className="mb-5">
                            <div className="text-center mb-4">
                                <Image className={styles['logo']} src={BreatheEV_Logo} alt="BreatheEV" />
                            </div>
                        </div>

                        <div className="card border border-light-subtle rounded-4">
                            <div className="card-body p-3 p-md-4 p-xl-5">
                                <h5 className={`mb-4 ${styles['login-title']}`}>Email verification</h5>
                                <div className="row gy-3 overflow-hidden">
                                    <div className="col-12 text-center">
                                        {isEmailVerified === null && <div>
                                            <Spinner animation="border" role="status" variant="secondary">
                                                <span className="visually-hidden">Loading...</span>
                                            </Spinner>
                                        </div>}
                                        <div>{verificationStatus}</div>
                                        {(isTokenExpired === true && isEmailSend !== true) && <div>
                                            <div className="col-12 mt-3">
                                                <div className="form-floating mb-3">
                                                    <input className="form-control" type="email" name="email" placeholder='Email' onChange={(e) => { setEmail(e.target.value); }} value={email} required />
                                                    <label htmlFor="email" className="form-label">Email</label>
                                                </div>
                                                <ButtonCustom
                                                    variant={"primary"}
                                                    text={"Resend verification email"}
                                                    isLoading={isEmailSend === null ? true : false}
                                                    onClick={reSendVerificationEmail}
                                                ></ButtonCustom>
                                            </div>
                                        </div>}
                                    </div>

                                    {isEmailVerified && <div className="col-12">
                                        <div className="d-grid">
                                            <ButtonCustom
                                                variant={"primary"}
                                                text={"Find a Time to Charge"}
                                                isLoading={false}
                                                onClick={handleGotoDashboard}
                                            ></ButtonCustom>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {isEmailVerified === false && <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center align-items-center mt-4">
                            <Link className="link-secondary text-decoration-none" to={`${process.env.REACT_APP_BASE_URL}/login`}>Back to Log in</Link>
                        </div>}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default EmailVerification;
